import urls, { prefetchConfig } from "./urls";

export default {
  // 获取页面信息
  asyncGetPageInfo: prefetchConfig(urls.getPageDetail, {
    id: "$query.id",
    activityId: "$query.activityId",
    activityRuleId: "$query.activityRuleId",
    releaseType: "$query.previewType",
  }),
};
